// extracted by mini-css-extract-plugin
export default {"header":"Abstract_header__Qicht"};